import './logo.svg';
import './social/hero.jpg';
